import {TableColumnsType} from 'antd';
import {SortOrder} from 'antd/lib/table/interface';

import {
    ReviewAnalysisCompaniesSortKeyType,
    ReviewAnalysisCompaniesSortType,
    ReviewAnalysisCompaniesSortValueEnum,
} from '../../../../../service/reivew-analysis/review-companies/review-companies-type';
import {ReviewsAndAnswersStatisticsUnitMeasurementEnum} from '../../../../../service/reviews-and-answers-statistics/reviews-and-answers-statistics';
import {SavedSortStateType} from '../../../../../util/save-sort-table-state/save-sort-table-type';
import {
    getAvgResponseDelayColumn,
    getCompanyCodeColumn,
    getCompanyColumn,
    getCompanyGroupsColumn,
    getRateColumn,
    getRepliedWithPercentageColumn,
    getSentimentColumn,
    getTotalColumn,
    getTrendColumn,
} from '../../components/table/reviews-analysis-table-helper';

import {ReviewCompaniesTableDataType, ReviewCompanyGroupsTableDataType} from './companies-page-type';

export const reviewAnalysisCompaniesCountSortersThreshold = 30_000;

export function getCompaniesPageTableColumns({
    timeUnit,
    allowSorter,
}: {
    timeUnit: ReviewsAndAnswersStatisticsUnitMeasurementEnum;
    allowSorter: boolean;
}): TableColumnsType<ReviewCompaniesTableDataType> {
    return [
        getCompanyColumn<ReviewCompaniesTableDataType>({
            isCompanyCodeShown: false,
            filterOnClick: true,
        }),
        {
            ...getRateColumn<ReviewCompaniesTableDataType>(),
            sorter: allowSorter,
        },
        getCompanyCodeColumn<ReviewCompaniesTableDataType>(),
        getCompanyGroupsColumn<ReviewCompaniesTableDataType>(),
        {
            ...getTotalColumn<ReviewCompaniesTableDataType>(),
            sorter: allowSorter,
        },
        {
            ...getRepliedWithPercentageColumn<ReviewCompaniesTableDataType>(),
            sorter: allowSorter,
        },
        {
            ...getAvgResponseDelayColumn<ReviewCompaniesTableDataType>(timeUnit),
            sorter: allowSorter,
        },
        getSentimentColumn<ReviewCompaniesTableDataType>(),
        getTrendColumn<ReviewCompaniesTableDataType>(),
    ];
}

export function getCompanyGroupsPageTableColumns({
    timeUnit,
}: {
    timeUnit: ReviewsAndAnswersStatisticsUnitMeasurementEnum;
}): TableColumnsType<ReviewCompanyGroupsTableDataType> {
    return [
        getCompanyGroupsColumn<ReviewCompanyGroupsTableDataType>('REVIEWS_ANALYSIS__TABLE__COLUMN__COMPANY_GROUP'),
        {
            ...getRateColumn<ReviewCompanyGroupsTableDataType>(),
            sorter: true,
        },
        {
            ...getTotalColumn<ReviewCompanyGroupsTableDataType>(),
            sorter: true,
        },
        {
            ...getRepliedWithPercentageColumn<ReviewCompanyGroupsTableDataType>(),
            sorter: true,
        },
        {
            ...getAvgResponseDelayColumn<ReviewCompanyGroupsTableDataType>(timeUnit),
            sorter: true,
        },
        getSentimentColumn<ReviewCompanyGroupsTableDataType>(),
        getTrendColumn<ReviewCompanyGroupsTableDataType>(),
    ];
}

export function serializeSortOrder(order?: SortOrder): ReviewAnalysisCompaniesSortValueEnum | null {
    if (order === 'ascend') {
        return ReviewAnalysisCompaniesSortValueEnum.Asc;
    }

    if (order === 'descend') {
        return ReviewAnalysisCompaniesSortValueEnum.Desc;
    }

    return null;
}

export function formatInitialStateSort(sortData: SavedSortStateType | null): ReviewAnalysisCompaniesSortType | null {
    const serializedOrder = serializeSortOrder(sortData?.order as SortOrder);

    if (!sortData || serializedOrder === null || sortData.field === null) {
        return null;
    }

    const sortKey = String(sortData.field);

    return `${sortKey as ReviewAnalysisCompaniesSortKeyType}.${serializedOrder}`;
}
